import axios from 'axios';

export class Authorizer {
    constructor(auth, url){
        this.auth = auth;
        this.url = url;
        this.response = "";
        this.errorMessage = "";
    }

    async callApi() {
        // Get the access token from the auth wrapper
        const token = await this.auth.getTokenSilently();

        // Use Axios to make a call to the API
        const { data } = await axios.get(this.url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return data;
    }

    async deleteManufacturer(man) {
        // Get the access token from the wrapper
        const token = await this.auth.getTokenSilently();

        // call the API
        await axios.delete(this.url, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            data: {
                man: man
            }
        })
        .then((response) => {
            console.log(response)
            this.response = response;
        })
        .catch((error) => {
            console.log(error);
            this.errorMessage = error;
        })

        return;
     }

    async postManufacturer(man) {
        // Get the access token from the wrapper
        const token = await this.auth.getTokenSilently();

        // call the API
        await axios.post(this.url, man, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            console.log(response)
            this.response = response;
            // dispatch({
            //     type: FOUND_USER,
            //     data: response.data
            // })
        })
        .catch((error) => {
            console.log(error);
            this.errorMessage = error;
            // dispatch({
            //     type: "Error"
            // })
        })

        return;
    }
}